var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActiveFilters',{key:_vm.activeFilterKey,attrs:{"value":_vm.activeFilters,"filters":_vm.getFilters},on:{"input":_vm.changeAllFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }